import { CommitteeMemberEndpoints } from "../api/admin/committeeMember.endpoints";
import APIrequest from "../lib/axios"

export const CommitteeMemberService = {
    async createCommitteeMember(data) {
        try {
            const payload = {
                ...CommitteeMemberEndpoints.createCommitteeMember,
                bodyData: data
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
    async getAllCommitteeMembers() {
        try {
            const payload = {
                ...CommitteeMemberEndpoints.getAllCommitteeMembers,
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
    async getCommitteeMember(id) {
        try {
            const payload = {
                ...CommitteeMemberEndpoints.getCommitteeMember(id),
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
    async updateCommitteeMember(id, data) {
        try {
            const payload = {
                ...CommitteeMemberEndpoints.updateCommitteeMember(id),
                bodyData: data
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
    async deleteCommitteeMember(id) {
        try {
            const payload = {
                ...CommitteeMemberEndpoints.deleteCommitteeMember(id),
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
}